<template>
  <div>
    <button @click="removeCookie">Remove Browser Cookie</button>
    <vue-cookie-accept-decline style="background-color: antiquewhite;border: 2px solid black;margin-bottom: 10px"
        :ref="'myPanel1'"
        :elementId="'myPanel1'"
        :debug="false"
        :position="'bottom-right'"
        :type="'floating'"
        :disableDecline="true"
        :transitionName="'slideFromBottom'"
        @status="cookieStatus"
        @clickedAccept="cookieClickedAccept"
        @clickedDecline="cookieClickedDecline"
        @removedCookie="cookieRemovedCookie">
      <div slot="message">
          {{this.datas.message}}<a href="/mentions-legales" target="_blank">{{this.datas.more_info}}</a>
      </div>
      <div slot="acceptContent">
        {{this.datas.acceptation}}
      </div>
    </vue-cookie-accept-decline>
  </div>
</template>

<script>
export default {
  name: "cx-cookie-accept",
  data () {
    return {
        status: null,
        datas: require('../../lang/' + process.env.VUE_APP_LANG + '/cookie.json')
    }
  },
  methods: {
    cookieStatus (status) {
      this.status = status
    },
    cookieClickedAccept () {
      this.status = 'accept'
    },
    cookieClickedDecline () {
      this.status = 'decline'
    },
    cookieRemovedCookie () {
      this.status = null
      this.$refs.myPanel1.init()
    },
    removeCookie () {
      this.$refs.myPanel1.removeCookie()
    }
  },
  computed: {
    statusText () {
      return this.status || 'No cookie set'
    }
  }
}
</script>
<style scoped>
    h1,
    h2 {
      font-weight: normal;
    }
    ul {
      list-style-type: none;
      padding: 0;
    }
    li {
      display: inline-block;
      margin: 0 10px;
    }
    a {
      color: #42b983;
    }
</style>